<template>
	<section>
		<div class='knd-map' ref='map'>
			<div class='knd-map-ol' id='map' style=""></div>
			<div class='knd-tooltip' ref='tooltip'>
				<div v-if="tooltipInfo">
					<div>{{tooltipInfo.naam}}</div>
					<div>{{tooltipInfo.straat}} {{tooltipInfo.stad}}</div>
				</div>
			</div>

			<Legenda />

			<div class='knd-tool'  v-show='showTool'>
				<div class='knd-nav'>
					<div class='knd-nav_inner'>
						<div class='knd-autocomplete' >
							<!-- <span class='tool-label'>zoek op</span> -->
								<input ref='awesomplete' placeholder='zoek op naam of adres school' />
						</div>
				</div>

				</div>
				<div class='knd-info' v-if="selectedProperties">
					<div class='m-b-sm'>
						<h3 class='knd-info__title'>{{selectedProperties.naam}} <span class='knd-info__address'>{{selectedProperties.straat}}, {{selectedProperties.stad}}</span></h3>
					</div>
					<div class='knd-info__meta'>
						<div v-if="selectedProperties.aantal">

							<div v-if="!hasHistoryInfo(selectedProperties.aantal)">In 2011 bestond deze school nog niet, daarom nemen we geen verandering waar. Hier zie je de situatie in 2021.</div>

							Binnen een <span class='mark mark--loopafstand'>loopafstand van 5 minuten</span> bevindt zich
							<table class='knd_info__table'>
								<thead>
									<tr>
										<th>type</th>
										<th v-if="hasHistoryInfo(selectedProperties.aantal)" scope="col">2011</th>
										<th scope="col">2021</th>
										<th v-if="hasHistoryInfo(selectedProperties.aantal)" scope="col">verschil</th>
									</tr>
								</thead>

								<tbody>
								<tr v-for="(item, index) in selectedProperties.aantal" :key='index'>
									<td>{{item.type}}</td>
									<td v-if="hasHistoryInfo(selectedProperties.aantal)" class="knd-row g-emphasize">{{item['2011'] === 'NA' ? '-': item['2011']}}</td>
									<td class="knd-row g-emphasize">{{item['2021']}}</td>
									<td v-if="hasHistoryInfo(selectedProperties.aantal)" class="knd-row g-emphasize">{{getDifference(item)}}</td>
								</tr>
							</tbody>
							</table>
						</div>
						<div v-else>
								Binnen 5 minuten lopen van deze school zijn er in 2021 geen ongezonde locaties gevonden.
						</div>
					</div>
				</div>
			</div>

		</div>
			<div class='knd-source'>
					Bron: <a href=' https://locatus.com/' target='_blank'>Locatus</a>
			</div>
	</section>
</template>

<script>

	// https://gis.stackexchange.com/questions/346459/openlayers-5-foreachfeatureintersectingextent-method-not-correctly-selecting-fea

	import Map from 'ol/Map';
	import View from 'ol/View';
	import XYZ from 'ol/source/XYZ';
	import {transformExtent, fromLonLat} from 'ol/proj';
	import Feature from 'ol/Feature';
	import {Circle as CircleStyle, Fill, Stroke, Style, Icon, RegularShape} from 'ol/style';
	import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
	import VectorSource from 'ol/source/Vector';
	import TopoJSON from 'ol/format/TopoJSON';
	import {Control, defaults as defaultControls} from 'ol/control';
	import {never} from 'ol/events/condition';

	import {getCurrentStyle, getRadiusStyle, getMarkerStyle} from './styles';

	import {Select, DragPan, MouseWheelZoom, defaults} from 'ol/interaction';
	import {platformModifierKeyOnly} from 'ol/events/condition';
	import {
		MultiPolygon,
		Point,
		Polygon,
		Circle
	} from 'ol/geom';

	import 'ol/ol.css';

	import {csv, json} from "d3-fetch";

	import Legenda from './legenda.vue';

	import aantalLocatiesCsv from '@/assets/csv/aantal_locaties_per_jaar_en_school_v2.csv';

	import * as Awesomplete from 'awesomplete';
	import 'awesomplete/awesomplete.css';

	import './kaart.scss';

	export default {
		name: 'Articles',
		components:{Legenda},

		mounted: function() {
			this.isMobile = this.mobileAndTabletCheck();
			this.draw();

			csv(process.env.VUE_APP_MYVAR + "/assets/ongezonde_locaties_2021.csv")
				.then((data) => {
					this.ongezondeLocaties = this.drawCircles(data);
					this.map.addLayer(this.ongezondeLocaties);
					this.ongezondeLocaties.setVisible(false);
				});

			json(process.env.VUE_APP_MYVAR + "/assets/polygons_en_coordinaten_scholen_v3.json")
				.then((data) => {
					this.scholenLocaties = this.drawPolygonen(data);
					this.map.getLayers().insertAt(1, this.scholenLocaties);

					this.renderAutoComplete(data);
				});

			this.aantalLocaties = this.groupByKey(aantalLocatiesCsv, 'id');
		},

		computed: {},
		watch: {},
		data: function() {
			return {
				tooltipInfo: undefined,
				selection: undefined,
				showTool: true,
				selected: null,
				hoverSelected: null,
				selectedProperties: null,
				isMobile: false
			}
		},
		methods: {

			getDifference(item) {
				let num = item['2011'] === 'NA' ? '-' :item['2021'] - item['2011'];

				return num > 0 ? '+' + num: num;
			},

			hasHistoryInfo(arr) {
				if(arr.length === 0) return;

				if (arr[0]['2011'] === 'NA') return false;

				return true;
			},

			getTypeColor(type) {
				let obj = {
					Supermarkt: '#FF6D61',
					Fastfood: '#8256FF',
					'Divers ongezond': '#43AD82'
				}

				let circleStyle = new Style({
					image: new CircleStyle({
						radius: 4,
						stroke: new Stroke({
							color: '#FFF',
							width: 1,
						}),
						fill: new Fill({
							color: obj[type],
						})
					}),
					zIndex: 150
				});				

				return circleStyle;
			},

			drawCircles(data) {
				let typeStyles = {
					Supermarkt: this.getTypeColor('Supermarkt'),
					Fastfood: this.getTypeColor('Fastfood'),
					'Divers ongezond': this.getTypeColor('Divers ongezond')
				}

				const features = [];
				let source = new VectorSource();

				data.forEach(d => {
					const coords = fromLonLat([+d.longitude, +d.latitude], 'EPSG:3857');

					features.push(
						new Feature({
							...d,
							geometry: new Point(coords),
						})
					);
				})

				source.addFeatures(features);
				let getTypeColor = this.getTypeColor;

				const newLocations = new VectorLayer({
					source: source,
					style: function (feature, resolution) {
						let type = feature.get('aanbiederstype');
						return typeStyles[type];
					},
				
					className: 'knd-locaties'
				});

				return newLocations;				
			},

			getPolygoneStyle(isActive) {

				let fillColor = isActive ? 'rgba(255, 250, 102, .9)' : 'rgba(255, 250, 102, .5)';
				let strokeColor = isActive ? '#8456FF' : 'rgba(255, 250, 102, 0)';
				let zIndex = isActive ? 100 : 0;
				const styles = [
					new Style({
						fill: new Fill({
							color: fillColor,
						}),
						zIndex: zIndex,
						stroke: new Stroke({
							color: strokeColor,
							width: 2
						})
					}),
					new Style({
						image: new CircleStyle({
							radius:2.5,
							stroke: new Stroke({
								color: '#000',
								width: 1,
							}),
							fill: new Fill({
								color: 'transparent',
							}),

						}),
						zIndex: zIndex,
						geometry: function (feature) {
							let properties = feature.getProperties();
							let lat = properties.lat;
							let lng = properties.lng;
							const coords = fromLonLat([+lng, +lat], 'EPSG:3857');

							return new Point(coords);
						},
					}),
				];		

				return styles;		
			},

			drawPolygonen(data) {
				let styles = this.getPolygoneStyle(false);

				const source = new VectorSource({
				
					features: new TopoJSON({layers: ['polygons_en_coordinaten_scholen (2)']}).readFeatures(data, {
							dataProjection: 'EPSG:4326',
							featureProjection: 'EPSG:3857'
					}),
				});

				const layer = new VectorLayer({
					source: source,
					style: styles,
					className: 'polygon'
				});				

				return layer;
			},

			draw() {
				var Esri_WorldGrayCanvas = new TileLayer({
					source: new XYZ({
						url: 'https://{1-4}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
							attributions: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
					}),
					subdomains: 'abcd',
					maxZoom: 20,
					minZoom: 4,
					bounds: [[50.5, 3.25], [54, 7.6]]					
				});

				this.view = new View({
					zoom: 11,
					minZoom: 4,
					maxZoom: 15,
					padding: [80, 10, 10, 10]
				})

				let dragging = true;

				if (this.isMobile) {
					dragging = false;
				}				

				this.map = new Map({
					controls: defaultControls(),
					interactions: defaults({
						dragPan: dragging, 
						mouseWheelZoom: false, 
						altShiftDragRotate:false, 
						pinchRotate:false})
					.extend([
						new DragPan({
							condition: function (event) {
								return this.getPointerCount() === 2 || platformModifierKeyOnly(event);
							},
						}),
						new MouseWheelZoom({
							condition: platformModifierKeyOnly,
						}),
					]),					
					target: 'map',
					layers: [
						Esri_WorldGrayCanvas
					],
					view: this.view
				});

				if(!this.isMobile) {
					this.map.on('pointermove', (e) => this.hoverFeatureInfo(e));
				}

				this.map.on('click', (e) => this.displayFeatureInfo(e));

				var extent = transformExtent(
					[3.3585237662812415,50.75119188403309,7.228097629289882,53.556553549681915],
					"EPSG:4326", "EPSG:3857"
				);

				this.map.getView().fit( extent, this.map.getSize() );
				var CenterOfGeom = this.map.getView().getCenter();

				var currZoom = this.map.getView().getZoom();
				this.map.on('moveend', (e) => {
					var newZoom = this.map.getView().getZoom();
					if (currZoom === newZoom) return;
					currZoom = newZoom;
					console.log(newZoom)
					if(newZoom > 11) {
						this.ongezondeLocaties.setVisible(true);
					} else {
						this.ongezondeLocaties.setVisible(false);
					}
				});				
			},

			mobileAndTabletCheck() {
				let check = false;
				(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
					return check;
			},

			numberWithCommas(x) {
				return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
			},

			groupByKey(array, key) {
				return array
					.reduce((hash, obj) => {
						if(obj[key] === undefined) return hash; 
						return Object.assign(hash, { [obj[key]]:( hash[obj[key]] || [] ).concat(obj)})
					}, {})
			},

			hoverFeatureInfo(e) {
				let tooltip = this.$refs.tooltip;
				let pixel = e.pixel;

				if (this.hoverSelected !== null ) {
					if(this.selected?.ol_uid !== this.hoverSelected.ol_uid) {
						this.hoverSelected.setStyle(undefined);
						this.hoverSelected = null;
					}
				}

				const feature = this.map.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
					if(layer.getClassName() !== 'polygon') return;
					return feature;
				});

				if (!feature) {
					this.hoverSelected = null;
					this.hideTooltip();
					return;
				}

				this.hoverSelected = feature;

				this.highlightSelected(feature);

				tooltip.classList.add('show');
				this.tooltipInfo = feature.getProperties();

				let padding = 15;
				let tooltipWidth = tooltip ? tooltip.offsetWidth : 0;
				let tooltipHeight = tooltip ? tooltip.offsetHeight : 0;

				let xPos = pixel[0];
				let yPos = pixel[1];

				let top = window.innerHeight > yPos + tooltipHeight + padding
					? yPos + padding
					: yPos - tooltipHeight - padding;


				let tooltipYpos = top;
				let tooltipXpos = xPos - (tooltipWidth /2);
				tooltip.style.left = tooltipXpos + 'px';
				tooltip.style.top = tooltipYpos + 'px';
			},

			highlightSelected(feature) {
				let styles = this.getPolygoneStyle(true);

				// selectStyle.getFill().setColor(feature.get('COLOR') || '#eeeeee');
				feature.setStyle(styles);

			},

			resetHighLight() {
				if (this.selected !== null) {
					this.selected.setStyle(undefined);
					this.selected = null;
				}
			},

			highlightFeature(feature) {
				this.resetHighLight();

				this.highlightSelected(feature);

				this.selected = feature;
				this.selectedProperties = feature.getProperties();

				let id = this.selectedProperties.id;

				this.selectedProperties.aantal = this.aantalLocaties[id];

				this.resetAutoComplete();
			},

			hideTooltip() {
				let tooltip = this.$refs.tooltip;
				tooltip.classList.remove('show');
			},

			displayFeatureInfo (e) {
				let pixel = e.pixel;

				const feature = this.map.forEachFeatureAtPixel(pixel, function (feature, layer) {
					if(layer.getClassName() !== 'polygon') return;
					return feature;
				});

				if (!feature) {
					this.resetHighLight();
					this.selectedProperties = null;	
					return;
				} 

				this.highlightFeature(feature);
			},

			zoomToFeature(id) {
				let layerSource = this.scholenLocaties.getSource();
				const features = layerSource.getFeatures();

				let selectedFeature;

				for (const feature of features) {
					if (feature.get("id")=== id){
						selectedFeature = feature;
						break;
					}
				}

				const extent = selectedFeature.getGeometry().getExtent();
				this.map.getView().fit(extent, { duration: 1000, padding: [100, 30, 0, 30] });

				this.highlightFeature(selectedFeature);
			},

			resetAutoComplete() {
				this.input = this.$refs.awesomplete;
				this.input.value = '';
			},

			renderAutoComplete(topo){				
				let scholen =	new TopoJSON({layers: ['polygons_en_coordinaten_scholen (2)']})
					.readFeatures(topo);

				let data = scholen.map(d => {
					let props = d.getProperties()
					return {label: props.naam + ' ~ ' + props.straat + ' ' + props.stad , value: props.id}
				});

				this.input = this.$refs.awesomplete;

				new Awesomplete(this.input, {
					list: data,
					maxItems: 20,
					item: function (text, input) {
						var html = input.trim() === '' ? text : text.replace(RegExp(Awesomplete.$.regExpEscape(input.trim()), "gi"), "<mark>$&</mark>");


							html = html.replace(RegExp(/\~(.*)$/, "gi"), "<span class='second'>$&</span>").replace('~', '')


							return Awesomplete.$.create("li", {
								innerHTML: html,
								"aria-selected": "false"
							});
					},
					replace: (suggestion) => {
						this.input.value = suggestion.label;

						let arr = suggestion.value;
						this.zoomToFeature(suggestion.value);
						this.selection = true;
						this.hideTooltip();
					}
				});

			}
		}
	}
</script>